export enum TestType {
  AB,
  ABC,
  ABCD,
  ABCDE
}

export enum TestSource {
  Flag,
  Experiment
}

export type Feature = {
  testType: TestType;
  testSource: TestSource;
  optimizely?: {
    key: string;
    variations: {
      [variation_key: string]: {
        value: any;
      };
    };
  };
};

const standardAB = (key: string) => ({
  key,
  variations: {
    A: { value: false }, // disabled
    B: { value: true } // enabled
  }
});

const _featureToggles = {
  ChatClient: {
    testType: TestType.AB,
    testSource: TestSource.Experiment,
    optimizely: standardAB('storageone__pax_chat_v2')
  },
  BestaPropping: {
    testType: TestType.AB,
    testSource: TestSource.Flag,
    optimizely: standardAB('storage_one__besta_propping')
  },
  EketPropping: {
    testType: TestType.AB,
    testSource: TestSource.Flag,
    optimizely: standardAB('storage_one__eket_propping')
  },
  PaxAutofill: {
    testType: TestType.AB,
    testSource: TestSource.Flag,
    optimizely: standardAB('storage_one_pax_autofill')
  },
  PaxAutofillMobile: {
    testType: TestType.AB,
    testSource: TestSource.Flag,
    optimizely: standardAB('storage_one_pax__autofill_mobile')
  },
  SummaryAssemblyService: {
    testType: TestType.AB,
    testSource: TestSource.Flag,
    optimizely: standardAB('storage_one_pax__summary_assembly_services')
  },
  SentryReplayLogging: {
    testType: TestType.AB,
    testSource: TestSource.Flag,
    optimizely: standardAB('storage_one_pax_sentry_logging')
  },
  OptimizeSpaceDefault: {
    testType: TestType.AB,
    testSource: TestSource.Flag,
    optimizely: standardAB('storage_one_platsa_optimize_space_default_tab')
  },
  BumerangHangers: {
    testType: TestType.AB,
    testSource: TestSource.Flag,
    optimizely: standardAB('storage_one_pax__bumerang')
  },
  BestaTopPanelImprovements: {
    testType: TestType.AB,
    testSource: TestSource.Flag,
    optimizely: standardAB('storage_one_besta__top_panel_improvements')
  },
  NewSummaryPageDesign: {
    testType: TestType.AB,
    testSource: TestSource.Flag,
    optimizely: standardAB('storage_one_pax__new_summary_page_design')
  }
};

const typed = <T extends Record<string, Feature>>(o: T): { [key in keyof T]: Feature } => o;

export const featureToggles = typed(_featureToggles);

export type FeatureToggle = keyof typeof featureToggles;
